import { useState } from 'react'

import { Box, Tab, Tabs } from '@mui/material'

import { VerticalTabPanel } from 'components/common'

import { CancellationOrLostReasons } from './CancellationOrLostReasons'
import OtherMiscellaneous from './OtherMiscellaneous'

function commonProps(index: TabId) {
  return {
    id: `setting-miscellaneous-tab-${index}`,
    'aria-controls': `setting-miscellaneous-tabpanel-${index}`,
  }
}

enum TabId {
  QuoteLostReasons = 0,
  OtherMiscellaneous,
}

const MiscellaneousTab = () => {
  const [tabValue, setTabValue] = useState(0)

  const tabs = {
    cancellationOrLostReasons: {
      id: TabId.QuoteLostReasons,
      label: 'Cancellation or Lost Reasons',
    },
    otherMiscellaneous: { id: TabId.OtherMiscellaneous, label: 'Other Miscellaneous' },
  }

  const handleChange = (_, newValue: number) => {
    setTabValue(newValue)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexGrow: 1,
        backgroundColor: (theme) => theme.palette.background.paper,
      }}>
      <Tabs
        value={tabValue}
        onChange={handleChange}
        orientation='vertical'
        aria-label='settings miscellaneous tabs'
        indicatorColor='primary'
        variant='scrollable'
        scrollButtons='auto'
        sx={{
          boxShadow: (theme) => `inset -2px 0 0 0 ${theme.palette.divider}`,
          width: (theme) => theme.spacing(27),
        }}>
        <Tab
          label={tabs.cancellationOrLostReasons.label}
          key={tabs.cancellationOrLostReasons.id}
          {...commonProps(tabs.cancellationOrLostReasons.id)}
        />
        <Tab
          label={tabs.otherMiscellaneous.label}
          key={tabs.otherMiscellaneous.id}
          {...commonProps(tabs.otherMiscellaneous.id)}
        />
      </Tabs>

      <VerticalTabPanel
        value={tabValue}
        index={tabs.cancellationOrLostReasons.id}
        key={tabs.cancellationOrLostReasons.id}
        px={3}>
        <CancellationOrLostReasons />
      </VerticalTabPanel>

      <VerticalTabPanel
        value={tabValue}
        index={tabs.otherMiscellaneous.id}
        key={tabs.otherMiscellaneous.id}
        px={3}>
        <OtherMiscellaneous />
      </VerticalTabPanel>
    </Box>
  )
}

export default MiscellaneousTab
